// Whether the user may open a route in the asset class of this page load. Some pages exist in one
// asset class only (Efficiency Tests are Investment Certificates only), and the URL alone — typed,
// bookmarked, left open in a tab, or reached through a switch — can point at them from another one.

export const UNAVAILABLE_ROUTE_NAME = 'asset-class-unavailable'

// Returns null when the route can be opened, or the location of the page that says it cannot.
// `can(permission)` answers for the selected asset class. Until the permissions are known nothing is
// refused: a failed user/info must not turn every page into "not available".
// A route whose permission does not depend on the asset class (`canValidate`) sets `meta.forbiddenRedirect`:
// "not available in this asset class" would be false for it, so the user is sent to that path instead.
export function accessRedirect(to, { can, permissionsLoaded }) {
  const required = to.meta && to.meta.requires
  if (!required || !permissionsLoaded || can(required)) {
    return null
  }
  if (to.meta.forbiddenRedirect) {
    return { path: to.meta.forbiddenRedirect, replace: true }
  }
  return { name: UNAVAILABLE_ROUTE_NAME, query: { from: to.fullPath }, replace: true }
}
